import { getColumnsByNames } from './all-top10-columns-config';

export const top10SourceDeniedColumns = getColumnsByNames([
    { name: 'rule' },
    { name: 'src' },
    { name: 'dport' },
    { name: 'count', width: '41%'  }
]);